import axios from "axios";

export function Notification(username, token) {
  return axios.get(process.env.REACT_APP_API_URI + "/notifications/all", {
    headers: {
      Authorization: username + ":" + token,
    },
  });
}
